import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHub12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconHub12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Hub12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M6.5 1.865a1 1 0 1 0-1 0v1.686a2.5 2.5 0 0 0-1.376.798L2.67 3.51a1 1 0 1 0-.508.862l1.465.845A2.5 2.5 0 0 0 3.632 6.8l-1.454.84a1 1 0 1 0 .491.87l1.466-.846c.352.394.827.676 1.365.785v1.686a1 1 0 1 0 1 0V8.449a2.5 2.5 0 0 0 1.376-.798l1.455.84a1 1 0 1 0 .508-.861l-1.465-.846A2.5 2.5 0 0 0 8.368 5.2l1.455-.84a1 1 0 1 0-.492-.87l-1.466.846A2.5 2.5 0 0 0 6.5 3.551zM6 7.5a1.499 1.499 0 1 0 0-2.998A1.499 1.499 0 0 0 6 7.5"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Hub12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconHub12);
